import { render, staticRenderFns } from "./ClienteDadosPerfomance.vue?vue&type=template&id=b0e0d330&scoped=true&"
import script from "./ClienteDadosPerfomance.vue?vue&type=script&lang=js&"
export * from "./ClienteDadosPerfomance.vue?vue&type=script&lang=js&"
import style0 from "./ClienteDadosPerfomance.vue?vue&type=style&index=0&id=b0e0d330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e0d330",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
